import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import serverList from "../../../components/serverList/serverOptions.vue";
import FillEmailMsg from "./fillEmailMsg.vue";
import { checkRole, saveEmail } from "@/api/data";
import { getInfoByID, getTempList, deleteTemp } from "@/api/temp";
import TempComp from "./tempComp.vue";
export default {
  components: {
    FillEmailMsg: FillEmailMsg,
    serverList: serverList,
    TempComp: TempComp
  },
  data: function data() {
    return {
      form: {},
      // selValue: "",
      options: [{
        value: 1,
        label: "玩家ID"
      }],
      //玩家ID字符串-》数组
      // playerIDString: "",
      playerNameString: "",
      isfillEmail: false,
      writeEmailType: 0,
      //点击编辑进入的
      formMsg: {},
      isEditPage: false,
      //选择模板,0否1是
      isTemp: 0,
      tempOptions: [],
      tempDialog: false,
      temp_value: "",
      selType: "",
      tempDialogId: 0,
      tempDialogName: ""
    };
  },
  computed: {
    playerIDString: {
      get: function get() {
        if (this.form.role_type == 1) {
          return this.form.role_list.toString();
        } else {
          return null;
        }
      },
      set: function set(newVal) {
        this.form.role_list = newVal.split(",");
        for (var i = 0; i < this.form.role_list.length; i++) {
          this.form.role_list[i] = this.form.role_list[i].trim();
        }
      }
    }
  },
  watch: {
    isTemp: {
      handler: function handler(newVal) {
        if (newVal == 0) {
          var data = {
            isEditPage: this.isEditPage,
            formInfo: this.formMsg
          };
          this.init(data);
        } else {
          if (this.temp_value == "") {
            var _data = {
              isEditPage: this.isEditPage,
              formInfo: this.formMsg
            };
            this.init(_data);
          } else {
            this.SelTemp(this.temp_value);
          }
        }
      }
    },
    temp_value: {
      handler: function handler(newVal) {
        this.SelTemp(newVal);
      }
    },
    playerNameString: {
      handler: function handler(newVal) {
        this.form.role_list = newVal.split(",");
      }
    }
  },
  created: function created() {
    this.getTemp();
  },
  methods: {
    getTemp: function getTemp() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, tempMap, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.tempOptions = [];
              _context.next = 3;
              return getTempList({
                page: 1,
                pageSize: 9999,
                temp_type: 1
              });
            case 3:
              res = _context.sent;
              if (res.code == 0) {
                tempMap = {};
                res.data.list.forEach(function (val) {
                  tempMap[val.id] = val.temp_name;
                });
                for (index in tempMap) {
                  _this.tempOptions.push({
                    id: index,
                    temp_name: tempMap[index]
                  });
                }
              }
              _this.tempDialog = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    init: function init(e) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.isEditPage = e.isEditPage;
              _this2.formMsg = e.formInfo;
              _this2.form = JSON.parse(JSON.stringify(e.formInfo));

              // if (e.isEditPage == true) {
              //     if (this.form.role_type == 1) {
              //         this.form.role_type = "1";
              //     } else {
              //         this.form.role_type = "玩家昵称";
              //     }
              // }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //多选选择框
    mulChange: function mulChange() {
      // this.$forceUpdate();
    },
    //选择框
    selPlayerChanged: function selPlayerChanged(value) {
      this.selValue = value;
    },
    SelTemp: function SelTemp(e) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var tempId, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              tempId = parseInt(e);
              _this3.tempDialogId = tempId;
              _context3.next = 4;
              return getInfoByID({
                id: tempId
              });
            case 4:
              res = _context3.sent;
              _this3.form = res.data.tempConfig.temp_content;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    tempBtn: function tempBtn() {
      this.tempDialogId = 0;
      this.tempDialogName = "";
      this.tempDialog = true;
    },
    deleteTempBtn: function deleteTempBtn() {
      var _this4 = this;
      deleteTemp({
        id: this.tempDialogId
      }).then(function (res) {
        if (res.code == 0) {
          _this4.$message({
            type: "success",
            message: "删除成功"
          });
          _this4.getTemp();
          // this.backTemp(0)
        } else {
          _this4.$message({
            type: "error",
            message: "删除失败"
          });
        }
      });
    },
    tempEditBtn: function tempEditBtn() {
      var _iterator = _createForOfIteratorHelper(this.tempOptions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          console.log(row);
          if (row.id == this.tempDialogId) {
            this.tempDialogName = row.temp_name;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      console.log(this.tempDialogId, this.tempDialogName);
      this.tempDialog = true;
    },
    backTemp: function backTemp(e) {
      this.isTemp = 1;
      this.temp_value = e.toString();
      this.getTemp();
    },
    checkAllEmail: function checkAllEmail() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res1, res, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return checkRole({
                roleList: _this5.form.role_list,
                serverId: _this5.form.server_id
              });
            case 2:
              res1 = _context4.sent;
              if (!(res1.code === 0)) {
                _context4.next = 8;
                break;
              }
              _context4.next = 6;
              return saveEmail(_this5.form);
            case 6:
              res = _context4.sent;
              if (res.code == 0) {
                _this5.$message({
                  message: "单人邮件，发送成功",
                  type: "success"
                });
                data = {
                  dialogFormVisible: false
                };
                _this5.$emit("backPersonEmail", data);
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};